module.exports = __webpack_public_path__ + "img/ukhavati.d9f9bec4.svg";